export const formatGameReviewValue = (value: unknown): string => {
  if (value === null || value === undefined || value === '') {
    return '—';
  }

  return String(value);
};

export const formatGameReviewCurrency = (value: unknown): string => {
  if (value === null || value === undefined || value === '') {
    return '—';
  }

  const amount = Number(value);

  if (Number.isNaN(amount)) {
    return String(value);
  }

  return `$${amount.toFixed(2)}`;
};
